import axios from 'axios';
import { smb_fetch, getSsoCgiUrl } from '@/api/operator/fetch';
import globalStore from '@/stores';

export const uploadFile = (data: { file: File }) => {
  const url = getSsoCgiUrl('cos_service/file', 'upload');
  const { file } = data;

  const formData = new FormData();
  formData.append('file', file);

  return axios
    .post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => response.data);
};

export const getSessionList = (data: any): Promise<any> => {
  const url = getSsoCgiUrl('eden/chat', 'log_list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': globalStore.account.bm_id || globalStore.account.agency_uid,
    },
    data,
  }, false, false).then((res) => res?.data || []);
};

export interface ISessionDetailResponse {
  check_finish: 0 | 1,
  log_list: any[],
}

export const getSessionDetail = (data: { session_id: string }): Promise<ISessionDetailResponse> => {
  const url = getSsoCgiUrl('eden/chat', 'log_detail');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': globalStore.account.bm_id || globalStore.account.agency_uid,
    },
    data,
  }, false, false).then((res) => res?.data as ISessionDetailResponse);
};

export const sendUserFeedback = (data: {
  agent_id: number;
  session_id: string;
  score: number;
  reasons?: string;
  suggestion?: string;
}) => {
  const url = getSsoCgiUrl('eden/agent', 'user_feedback');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': globalStore.account.bm_id || globalStore.account.agency_uid,
    },
    data,
  }, false, false).then((res) => res?.data);
};

export const chatDirect = (data: any) => {
  const url = getSsoCgiUrl('eden', 'chatDirect');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': globalStore.account.bm_id || globalStore.account.agency_uid,
    },
  }, false, false).then((res) => res?.data);
};

export const addBoard = (data: any) => {
  const url = getSsoCgiUrl('eden/board', 'add');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': globalStore.account.bm_id || globalStore.account.agency_uid,
    },
  }, true, false);
};

export const reportException = (data: any) => {
  const url = getSsoCgiUrl('eden/board', 'report_exception');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, false, false);
};

export type IAIDashboardList = {
  /** 看板ID */
  board_id: number;
  /** 看板名称 */
  board_name: string;
  /** 看板地址 */
  board_url: string;
  /** 用户ID */
  user_id: number;
  /** 会话ID */
  session_id: string;
}[];
export const getAIDashboardList = (): Promise<IAIDashboardList> => {
  const url = getSsoCgiUrl('eden/board', 'list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': globalStore.account.bm_id || globalStore.account.agency_uid,
    },
    data: {},
  }, false, false).then((res) => (res?.data || []) as IAIDashboardList);
};

export const deleteAIDashboard = (data: any) => {
  const url = getSsoCgiUrl('eden/board', 'delete');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    headers: {
      'x-platform-type': 2, // 1：工作台  2.服务商
      'x-account-id': globalStore.account.bm_id || globalStore.account.agency_uid,
    },
  }, true, false);
};
